export const PlusMinus = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 12 12" fill="none" {...props}>
      <path d="M6 1C6.34715 1 6.57143 1.2897 6.57143 1.64706V3.94118L9.37143 3.94118C9.71858 3.94118 10 4.17205 10 4.52941C10 4.88677 9.71858 5.11765 9.37143 5.11765L6.57143 5.11765V8C6.57143 8.35736 6.34715 8.64706 6 8.64706C5.65285 8.64706 5.42858 8.35736 5.42858 8V5.11765H2.62857C2.28142 5.11765 2 4.88677 2 4.52941C2 4.17205 2.28142 3.94118 2.62857 3.94118L5.42858 3.94118V1.64706C5.42858 1.2897 5.65285 1 6 1Z" />
      <path d="M2.62857 9.82353C2.28142 9.82353 2 10.0544 2 10.4118C2 10.7691 2.28142 11 2.62857 11H9.37143C9.71858 11 10 10.7691 10 10.4118C10 10.0544 9.71858 9.82353 9.37143 9.82353H2.62857Z" />
    </svg>
  );
};
